import { createRequestTypes } from "../../../utils/createActionTypes";

export const GET_CURRENCY = createRequestTypes("GET_CURRENCY")
export const GET_CURRENCIES = createRequestTypes("GET_CURRENCIES")
export const CREATE_CURRENCY = createRequestTypes("CREATE_CURRENCY")
export const UPDATE_CURRENCY = createRequestTypes("UPDATE_CURRENCY")
export const DELETE_CURRENCY = createRequestTypes("DELETE_CURRENCY")
export const SEARCH_CURRENCY = createRequestTypes("SEARCH_CURRENCY")
